import { t } from 'i18next';
import { FC } from 'react';
import { MdOutlineArrowBack } from 'react-icons/md';
import { IconButton } from '../../../components/icon-button/icon-button';
import { Modal, ModalProps } from '../../../components/modal/modal';
import { validate } from '../../../helpers/validate';
import { WorkingHoursType } from '../types';
import { WorkingHours } from '../working-hours';
import s from './working-hours-modal.module.css';

interface Props extends Omit<ModalProps, 'data'> {
  handleUpdateSpecs: (specs: WorkingHoursType['specs']) => void;
  handleUpdateWeek: (week: WorkingHoursType['week']) => void;
  data?: WorkingHoursType;
  onSave?: () => void;
}

const isValidTime = (time: string) => {
  return time.replace('__', '').length === 5;
};

export const WorkingHoursModal: FC<Props> = (props) => {
  const { data, handleUpdateSpecs, handleUpdateWeek, onSave, ...other } = props;

  const handleSave = () => {
    const week = data?.week;

    const fromRules: Record<string, { rule: () => boolean }> = {};
    const toRules: Record<string, { rule: () => boolean }> = {};
    Array(7)
      .fill(0)
      .forEach((_, index) => {
        const day = week?.[index];
        const [from, to] = day?.split('-') || [];
        fromRules[`from-${index}`] = { rule: () => isValidTime(from) };
        toRules[`to-${index}`] = { rule: () => isValidTime(to) };
      });

    const specs = data?.specs;
    const specRules: Record<string, { rule: () => boolean }> = {};
    specs?.forEach((_, index) => {
      const spec = specs[index];
      const [from, to] = spec.time?.split('-') || [];
      specRules[`spec-date-${index}`] = { rule: () => !!spec.date };
      specRules[`spec-from-${index}`] = { rule: () => isValidTime(from) };
      specRules[`spec-to-${index}`] = { rule: () => isValidTime(to) };
    });

    const isValid = validate({ ...fromRules, ...toRules, ...specRules });

    if (!isValid) return;
    onSave?.();
  };
  return (
    <Modal
      {...other}
      className={s.feature}
      title={
        <div className={s.title}>
          <IconButton
            variant="ghost"
            className={s.icon}
            onClick={props.onClose}
            data-testid="working-hours-close-button"
          >
            <MdOutlineArrowBack />
          </IconButton>
          <div className={s.content}>
            <h3>{t('Установить меню по времени')}</h3>
            <h4>{t('Настройте меню по собственному графику работы')}</h4>
          </div>
        </div>
      }
    >
      <WorkingHours
        handleUpdateSpecs={handleUpdateSpecs}
        handleUpdateWeek={handleUpdateWeek}
        handleSave={handleSave}
        data={data}
      />
    </Modal>
  );
};
